import React from 'react';
import { Box, Skeleton } from '@mui/material';

function EngagementSkeleton() {
    return (
        <Box className="padding-t-24-b-0-rl-24">
            <Skeleton variant="text" />
            <Box className="flex-row-space-between">
                <Box>
                    <Skeleton variant="text" width={50} height={32}/>
                </Box>
                <Box>
                    <Box className="flex-row gap-4">
                        <Skeleton variant="text" width={16} height={16} />
                        <Skeleton variant="text" width={30} height={18} />
                    </Box>
                    <Skeleton variant="text" width={70} height={18}/>
                </Box>
            </Box>
            <Box className="pb-20px">
                <Skeleton variant="rounded" height={120} />
            </Box>
        </Box>
    );
}

export default EngagementSkeleton;
